module.exports = __webpack_public_path__ + "img/coal_video.a9c54ff3.png";